import { findIndex } from 'lodash';
import {
  getFestivalAction,
  getFestivalProductionsAction,
  getFestivalContactsAction,
  updateFestivalAction,
  getCompaniesAction,
  getFestivalDescriptionsAction,
  createFestivalDescriptionAction,
  deleteFestivalDescriptionAction,
  updateFestivalDescriptionAction,
  addAndUpdateFestivalContactsAction,
  updateFestivalInfoAction,
  getFestivalVenuesAction,
} from './actions';
import { namedEntityParams, entityReducer, namedListParams, listReducer } from '../../utils/crudUtils';
import { CLEAR_FESTIVAL_PRODUCTIONS, SET_FESTIVAL, SET_INIT_PRODUCTIONS } from './constants';

export const key = 'Festival';

export const initialState = {
  contacts: namedListParams('contacts'),
  festivalContactsUpdating: false, // as there are several requests and festival info update
  festival: namedEntityParams('festival'),
  performances: namedListParams('performances'),
  companies: namedListParams('companies'),
  loadingFieldName: '',
  descriptions: namedListParams('descriptions'),
  venues: namedListParams('venues'),
  viewInitialProductionsData: {
    data: {},
    query: {},
  },
};

const festivalReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getFestivalAction.TRIGGER:
    case getFestivalAction.SUCCESS:
    case getFestivalAction.FAILURE:
      return entityReducer(state, type, payload, initialState.festival.entityName);

    case getFestivalContactsAction.TRIGGER:
    case getFestivalContactsAction.SUCCESS:
    case getFestivalContactsAction.FAILURE:
      return listReducer(state, type, payload, initialState.contacts.listName);

    case getFestivalProductionsAction.TRIGGER:
    case getFestivalProductionsAction.SUCCESS:
    case getFestivalProductionsAction.FAILURE:
      return listReducer(state, type, payload, initialState.performances.listName);

    case updateFestivalInfoAction.TRIGGER: // as we update company info with contacts together
    case addAndUpdateFestivalContactsAction.TRIGGER:
      return { ...state, festivalContactsUpdating: true };
    case addAndUpdateFestivalContactsAction.SUCCESS:
    case addAndUpdateFestivalContactsAction.FAILURE:
      return { ...state, festivalContactsUpdating: false };

    case SET_FESTIVAL:
      return {
        ...state,
        [initialState.festival.entityName]: {
          ...state[initialState.festival.entityName],
          entity: payload,
          loadedOnce: true,
        },
      };

    // for display pages only
    case SET_INIT_PRODUCTIONS:
      return {
        ...state,
        viewInitialProductionsData: {
          data: payload?.data,
          query: payload?.query,
        },
      };

    case updateFestivalAction.TRIGGER:
    case updateFestivalAction.SUCCESS:
    case updateFestivalAction.FAILURE:
      return {
        ...listReducer(state, type, payload, initialState.festival.entityName),
        loadingFieldName: payload?.fieldName || '',
      };

    case getCompaniesAction.TRIGGER:
    case getCompaniesAction.SUCCESS:
    case getCompaniesAction.FAILURE:
      return {
        ...listReducer(state, type, payload, initialState.companies.listName),
        loadingFieldName: payload?.fieldName || '',
      };

    case getFestivalDescriptionsAction.TRIGGER:
    case getFestivalDescriptionsAction.SUCCESS:
    case getFestivalDescriptionsAction.FAILURE:
      return listReducer(state, type, payload, initialState.descriptions.listName);

    case createFestivalDescriptionAction.TRIGGER:
    case updateFestivalDescriptionAction.TRIGGER:
      return { ...state, descriptions: { ...state.descriptions, isDescriptionUpdating: true } };
    case createFestivalDescriptionAction.FAILURE:
    case updateFestivalDescriptionAction.FAILURE:
      return { ...state, descriptions: { ...state.descriptions, isDescriptionUpdating: true } };

    case createFestivalDescriptionAction.SUCCESS:
      return {
        ...state,
        descriptions: {
          ...state.descriptions,
          data: [...state.descriptions.data, payload.entity],
          isDescriptionUpdating: false,
        },
      };

    case deleteFestivalDescriptionAction.TRIGGER:
      return { ...state, descriptions: { ...state.descriptions, loading: true } };
    case deleteFestivalDescriptionAction.SUCCESS: {
      return {
        ...state,
        descriptions: {
          ...state.descriptions,
          data: state.descriptions.data.filter(d => d?.id !== payload?.id),
          loading: false,
        },
      };
    }
    case deleteFestivalDescriptionAction.FAILURE:
      return { ...state, descriptions: { ...state.descriptions, loading: false } };

    case updateFestivalDescriptionAction.SUCCESS: {
      const updatedDescriptionIndex = findIndex(state?.descriptions?.data, { id: payload?.entity?.id });
      return {
        ...state,
        descriptions: {
          ...state.descriptions,
          data: Object.assign([], state.descriptions.data, { [updatedDescriptionIndex]: payload.entity }),
          isDescriptionUpdating: false,
        },
      };
    }

    case CLEAR_FESTIVAL_PRODUCTIONS:
      return { ...state, [initialState.performances.listName]: namedListParams(initialState.performances.listName) };

    case getFestivalVenuesAction.TRIGGER:
    case getFestivalVenuesAction.SUCCESS:
    case getFestivalVenuesAction.FAILURE:
      return listReducer(state, type, payload, initialState.venues.listName);

    default:
      return state;
  }
};

export default festivalReducer;
